<form #myForm [formGroup]="formGroup">
  <div fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="20px" style="width: 100%;  ">
    <div>
      <kendo-label text="Number: ">
        <kendo-dropdownlist #numberDDL formControlName="number"
                            [data]="hierarchyNumberArray"
                            (valueChange)="hierarchyNumberChange($event)"
                            textField="storeConcatLvl"
                            valueField="value">
        </kendo-dropdownlist>
      </kendo-label>
    </div>
    <div>
      <kendo-label text="Name: ">
        <kendo-textbox #nameTB formControlName="name">
        </kendo-textbox>
      </kendo-label>
    </div>
  </div>
  <div fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="20px" style="width: 100%;margin-top: 10px  ">
    <div>
      <kendo-label text="Type: ">
        <kendo-dropdownlist #typeDDL
                            formControlName="type"
                            [data]="hierarchyTypeArray"
                            (valueChange)="hierarchyTypeChange($event)"
                            textField="type"
                            valueField="value">
        </kendo-dropdownlist>
      </kendo-label>
    </div>
    <div>
      <kendo-label text="Description: ">
        <kendo-textbox #descTB formControlName="description" >
        </kendo-textbox>
      </kendo-label>
    </div>
  </div>
  <div fxLayout="row" fxLayoutAlign="space-between center" style="width: 100%; margin-top: 10px  ">
    <div>
      <kendo-label text="Parent: ">
        <kendo-dropdownlist #parentDDL
                            formControlName="parent"
                            [data]="hierarchyParentArray"
                            textField="key"
                            valueField="value">
        </kendo-dropdownlist>
      </kendo-label>
    </div>
    <div style="width: 200px">
    </div>
  </div>
  <div fxLayout="row" fxLayoutAlign="space-around center" style="width: 100%; margin-top: 20px; ">
    <button kendoButton (click)="add()" [disabled]="myForm.invalid || myForm.pristine || addDisabled" [primary]="true" style="width: 62px;">Add</button>
    <button kendoButton (click)="update()" [disabled]="myForm.invalid || myForm.pristine" [primary]="true">Update
    </button>
    <button kendoButton [disabled]="deleteDisabled" (click)="delete()" [primary]="true">Delete
    </button>


    <button kendoButton (click)="clear()" [primary]="true" style="width: 62px;">Clear</button>
  </div>
</form>

